import React, { useEffect, useMemo } from 'react';
import { Bot } from 'lucide-react';
import {
  BUILDER_MODEL_GROUPS,
  listAvailableBuilderModels,
  pickDefaultBuilderModel,
} from '../../data/builderModels';

export default function AppBuilderModelPicker({
  cloudKeys,
  value,
  onChange,
  defaultFromSettings,
  className = '',
}) {
  const available = useMemo(() => listAvailableBuilderModels(cloudKeys || {}), [cloudKeys]);

  useEffect(() => {
    const next = pickDefaultBuilderModel(cloudKeys || {}, defaultFromSettings || value);
    if (next !== value) onChange(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloudKeys, defaultFromSettings]);

  const configuredGroups = BUILDER_MODEL_GROUPS.filter((g) =>
    available.some((m) => m.keyId === g.keyId),
  );

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="app-builder-model-picker">
      <Bot className="h-3.5 w-3.5 shrink-0 text-violet-300" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 max-w-[200px] rounded-lg border border-white/[0.08] bg-white/[0.03] px-2 text-xs text-zinc-200 focus:border-violet-500/40 focus:outline-none"
        title="Model for this build"
      >
        {available.length === 0 ? (
          <option value={value || 'gpt-4o-mini'}>
            {value || 'gpt-4o-mini'} (add API key in Settings)
          </option>
        ) : (
          configuredGroups.map((group) => (
            <optgroup key={group.keyId} label={group.label}>
              {group.models
                .filter((m) => available.some((a) => a.id === m.id))
                .map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.label}
                  </option>
                ))}
            </optgroup>
          ))
        )}
      </select>
    </div>
  );
}
